import { objectOf, anyOf, is } from "@altostra/type-validations";
import { boolean, string, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

export const isKnowledgeSourceDefinitionResultObject = objectOf({
  id: string,
  name: string,
  description: string,
  status: string,
  syncing_from_dashboard_trigger: boolean,
  created_at: string,
  updated_at: string,
  created_by_email: string,
  type: is("catalog"),
  catalog_id: string,
  last_synced_at: anyOf(string, nullOrUndefined),
});

export const isKnowledgeSourceDefinitionIdResult = objectOf({
  result: isKnowledgeSourceDefinitionResultObject,
});
